import { ChangeEventHandler, InputHTMLAttributes, FC, ReactNode } from 'react';

import UploadFill from '@o2/icons/UploadFill';
import Button, { ButtonProps } from '@o2/ui/Button';

export interface FileUploadButtonProps extends Omit<ButtonProps, 'component' | 'onChange' | 'startIcon' | 'variant'> {
  /**
   * Element html ID.
   *
   * If you don't care about the value, you can use `useId` (React 18+) or `unstable_useId` (MUI 5).
   */
  id: string;
  /**
   * Text on button
   */
  label: ReactNode;
  /**
   * Input name
   */
  name?: string;
  /**
   * Change event handler
   */
  onChange?: ChangeEventHandler;
  /**
   * Icon on button
   */
  icon?: ReactNode;
  /**
   * Props passed to the `<input type="file" />`.
   */
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
}

const defaultIcon = <UploadFill />;

/**
 * FileUploadButton is a simple styled file input.
 */
const FileUploadButton: FC<FileUploadButtonProps> = ({
  label,
  onChange,
  name,
  id,
  icon = defaultIcon,
  disabled,
  inputProps,
  ...other
}) => {
  return (
    <label htmlFor={id}>
      <input id={id} type="file" name={name} onChange={onChange} hidden disabled={disabled} {...inputProps} />
      <Button variant="outlined" startIcon={icon} component="span" disabled={disabled} {...other}>
        {label}
      </Button>
    </label>
  );
};

export default FileUploadButton;
